import _ from "lodash";

import {
  FETCH_THREATS,
  FETCH_THREATS_FAILURE,
  FETCH_THREATS_SUCCESS,
  ThreatsActionTypes,
  ThreatsListReducerState,
} from "./threats.types";
import { normalize } from "../../utils/normalize";
import { CHANGE_LANGUAGE_SUCCESS } from "../attributes/attributes.types";
import { initialLoadableState, withLoadingState } from "../shared";

const initialState: ThreatsListReducerState = {
  ...initialLoadableState,
  list: {},
  keys: [],
};

const reducer = (
  state = initialState,
  action: ThreatsActionTypes
): ThreatsListReducerState => {
  switch (action.type) {
    case CHANGE_LANGUAGE_SUCCESS:
      return initialState;
    case FETCH_THREATS_SUCCESS:
      const threatsWithSeverity = _.map(action.payload, (threat) => {
        return _.defaults(threat, { severity: 0 });
      });

      return { ...state, ...normalize<number>(threatsWithSeverity) };
    default:
      return state;
  }
};

export const threatsReducer = withLoadingState({
  loadActionType: FETCH_THREATS,
  successActionType: FETCH_THREATS_SUCCESS,
  failureActionType: FETCH_THREATS_FAILURE,
})(reducer);
